module.exports = __webpack_public_path__ + "static/media/al.06632346.svg";